import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { ProcessingAttrsBase } from "../../../interfaces/orion";
import StatusIcon from "../../Orion/StatusIcon";
import { DialogProps } from "../useDialogs";

export interface ProcessingHistoryDialogProps {
  processingId: string | undefined;
  history: ProcessingAttrsBase[];
  setProcessingId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const ProcessingHistoryDialog = ({
  payload,
  open,
  onClose,
}: DialogProps<ProcessingHistoryDialogProps>) => {
  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="md" fullWidth>
      <DialogTitle>Historique des traitements</DialogTitle>
      <DialogContent>
        {payload.history.length === 0 ? (
          <Typography variant="body2" color="text.secondary" align="center">
            Aucun historique...
          </Typography>
        ) : (
          <List dense>
            {payload.history.map((processing) => (
              <ListItem
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
                key={processing._id}
                divider
                onClick={() => {
                  payload.setProcessingId(processing._id);
                  onClose();
                }}
              >
                <ListItemText
                  slotProps={{
                    primary: {
                      sx: {
                        fontWeight:
                          processing._id === payload.processingId
                            ? "bold"
                            : "normal",
                      },
                    },
                    secondary: {
                      sx: {
                        fontWeight:
                          processing._id === payload.processingId
                            ? "bold"
                            : "normal",
                      },
                    },
                  }}
                  primary={`${new Date(processing.insertion_date).toLocaleString()}`}
                  secondary={
                    processing.config_char
                      ? `Configuration: ${processing.config_char?.name}`
                      : ""
                  }
                />
                <StatusIcon status={processing.status} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProcessingHistoryDialog;
